import ImagePicker from '@dyl/components/ImagePicker';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import React from 'react';

export default function AdditionalImageEditor({ index }) {
    const [imageId, setImageId, imageError] = useTaskField('items', index, 'answers', 0, 'image_id');

    return (
        <ImagePicker
            label='Prompt Image'
            value={imageId ?? ''}
            onChange={setImageId}
            helperText={imageError || 'Must be 800x500px'}
            error={!!imageError}
        />
    );
}